import type { Resource } from "i18next";

export const resources = {
  en: {
    translation: {
      "Discover Horizon":
        "Horizon is a tool notably designed for counselors and social workers helping people who are far from employment: project identification, job offers,  service offers (housing, mobility, health...), communication via SMS... Our motto : simplifying your work and helping enhance the growth of the people you follow.",
      "Welcome to Horizon": "Welcome to Horizon,",
      "Log in": "Log in",
      password: "Password",
      email: "Email",
      "Sign In": "Sign in",
      "Forgot password": "Forgot password ?",
      "Sign In with Google": "Sign in with Google",
      "Sign In with Microsoft": "Sign in with Microsoft",
      "Sign In with ADFS": "Sign in with my pro account (SSO)",
      "Sign In with ProConnect": "S'identifier avec ProConnect",
      "What is ProConnect": "What is ProConnect?",
      "Sign In with Pôle Emploi": "Sign in with Pôle Emploi",
      Cancel: "Cancel",
      "Reset Password": "Reset password",
      "Reinit password description": "Please enter your email to reset your password",
      "Modify Password": "Modify your password",
      "New Password": "Create a new password",
      "Confirm your Password": "Confirm your password",
      "Resetting Password": "Resetting your password,",
      "Enter your new password": "Please enter your new password",
      Copyright: "BimBamJob, All rights reserved.",
      "Privacy Policy": "Privacy Policy",
      "Forgot Password Title": "Forgot your password,",
      "Password Label": "Password",
      "Confirm Password Label": "Confirm password",
      Continue: "Continue",
      "Send confirmation link": "Send confirmation link",
      "Send reset link": "Send reset link",
      "Password Rules":
        "Password must contain at least 12 characters (including 1 lowercase, 1 uppercase, 1 number, 1 special character).",
    },
  },
  fr: {
    translation: {
      "Discover Horizon":
        "Horizon, c’est un outil qui aide notamment les conseillers en insertion et les référents dans l’accompagnement et le suivi des personnes éloignées de l’emploi : identification des projets et des défis, proposition d’offres d’emploi et d’offres de services (logement, mobilité, santé...), gestion des SMS... Notre credo : simplifier votre travail et valoriser l’évolution des personnes que vous accompagnez.",
      "Welcome to Horizon": "Bienvenue sur Horizon",
      "Log in": "Connectez-vous à votre compte",
      password: "Mot de passe",
      email: "Email",
      "Sign In": "Se connecter",
      "Forgot password": "Mot de passe oublié ?",
      "Sign In with Google": "Se connecter avec Google",
      "Sign In with Microsoft": "Se connecter avec Microsoft",
      "Sign In with ADFS": "Se connecter avec mon SSO",
      "Sign In with ProConnect": "S'identifier avec ProConnect",
      "What is ProConnect": "Qu'est-ce que ProConnect ?",
      "Sign In with Pôle Emploi": "Se connecter avec Pôle Emploi",
      Cancel: "Annuler",
      "Reset Password": "Réinitialiser votre mot de passe",
      "Reinit password description": "Veuillez renseigner votre email pour réinitialiser le mot de passe",
      "Modify Password": "Modifier le mot de passe",
      "New Password": "Créer un nouveau mot de passe",
      "Confirm your Password": "Confirmation de votre mot de passe",
      "Resetting Password": "Réinitialisation de votre mot de passe,",
      "Enter your new password": "Veuillez renseigner votre nouveau mot de passe",
      Copyright: "BimBamJob, Tous droits réservés.",
      "Privacy Policy": "Politique de confidentialité",
      "Forgot Password Title": "Mot de passe oublié,",
      "Password Label": "Mot de passe",
      "Confirm Password Label": "Confirmer ce mot de passe",
      Continue: "Continuer",
      "Send confirmation link": "Envoyer le lien de confirmation",
      "Send reset link": "Envoyer le lien de réinitialisation",
      "Password Rules":
        "Le mot de passe doit contenir 12 caractères min (dont 1 minuscule, 1 majuscule, 1 chiffre, 1 caractère spécial).",
    },
  },
} as const satisfies Resource;
